import { createSlice } from "@reduxjs/toolkit";

const getInitialMentorSelectedTutorial = () => {
  const isTutorialInURL = window?.location?.href?.includes("tutorials");
  return isTutorialInURL;
};

const initialState = {
  isTutorialGlobal: false,
  isMentorSelectedTutorial: getInitialMentorSelectedTutorial(),
};
const tutorialSlice = createSlice({
  name: "tutorial",
  initialState,
  reducers: {
    setIsTutorialGlobalStatus: (state, action) => {
      state.isTutorialGlobal = action.payload;
    },
    setIsMentorSelectedTutorial: (state, action) => {
      state.isMentorSelectedTutorial = action.payload;
    },
  },
});

export const { setIsTutorialGlobalStatus, setIsMentorSelectedTutorial } =
  tutorialSlice.actions;
export const fetchIsTutorialGlobal = (state) => state.tutorial.isTutorialGlobal;
export const fetchMentorSelection = (state) =>
  state.tutorial.isMentorSelectedTutorial;
export default tutorialSlice.reducer;
